import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
function buildMonths(
  startDate ,
  monthsForward ,
  locale
) {
  const fmt = new Intl.DateTimeFormat(locale, { month: "long" });
  const byYear = new Map();

  for (let i = 0; i < monthsForward; i++) {
    const d = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
    const y = d.getFullYear();
    const m = d.getMonth() + 1; // 1..12
    const mm = String(m).padStart(2, "0");
    const key = `${y}-${mm}`;
    const label = fmt.format(d);

    // last day of this month
    const lastDay = new Date(y, m, 0).getDate();
    const min = `${y}-${mm}-01`;
    const max = `${y}-${mm}-${String(lastDay).padStart(2, "0")}`;

    const item = { year: String(y), month: m, key, label, min, max };

    if (!byYear.has(item.year)) byYear.set(item.year, []);
    byYear.get(item.year).push(item);
  }

  const years = Array.from(byYear.keys()); // ordered
  const grouped = Object.fromEntries(byYear.entries());
  return { years, grouped };
}

const Calendar24Months = ({updateUtilityDates,billingPeriod,siteCreated,projectStatusData}) => {
  // Store selected dates as map: YYYY-MM -> Date
  const [selectedDates, setSelectedDates] = useState({});
  const datePickerRef = useRef(null);
   const [openKey, setOpenKey] = useState(null); 
  const { years, grouped } = useMemo(() =>{
    const siteCreatedOrCompleted =  siteCreated ||
            projectStatusData?.projectStatus === "COMPLETED" ||
            projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
    if(siteCreatedOrCompleted){
      const firstDay = billingPeriod?.customDays?.sort((a, b) => new Date(a) - new Date(b))?.[0];
     return buildMonths(new Date(firstDay), 24,"default");
    }else{
      return buildMonths(new Date(), 24,"default");
    }
     
    
    }
  , []);
  const [activeYear, setActiveYear] = useState(null);

  useEffect(() => {
    // do payload here
   let updateDates = formatDate(selectedDates)
    updateUtilityDates(updateDates)
  }, [selectedDates]);
 useEffect(()=>{
    // set response here
    handleBackendResponse(billingPeriod?.customDays || []);
 },[])
  useEffect(() => {
    if (!activeYear && years.length > 0) setActiveYear(years[0]);
  }, [years, activeYear]);
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setOpenKey(null);
      } else if (e.key === "Tab") {
        // allow focus change then close
        setOpenKey(null)
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);
  const parseDDMMYYYY = (str) => {
    const [year, month, day] = str.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const handleBackendResponse = (datesArray) => {
    const today = new Date();
    today.setHours(0,0,0,0);
    const parsed = {};
    datesArray.forEach((dateStr) => {
      const dateObj = parseDDMMYYYY(dateStr);
      if (isNaN(dateObj)) return; // skip invalid
      const key = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}`;
      // If date belongs to current month/year but is before today, skip it (disable retention)
      if (
        dateObj.getFullYear() === today.getFullYear() &&
        dateObj.getMonth() === today.getMonth() &&
        dateObj < today
      ) {
      //  parsed[key] = dateObj;
       // do not keep an invalid past day selection in current month
       return;
      }
      parsed[key] = dateObj; // store Date object
    });
    setSelectedDates(parsed);
  };
  const handleDateChange = useCallback((key, date) => {
    // Allow clearing (date null/undefined)
    if (!date) {
      setSelectedDates(prev => {
        if (!prev[key]) return prev;
        const next = { ...prev };
        delete next[key];
        return next;
      });
      return;
    }
    if (!(date instanceof Date) || isNaN(date)) return;
    const today = new Date();
    today.setHours(0,0,0,0);
    // Prevent selecting a past day in the current month
    if (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date < today
    ) {
      return;
    }
    setSelectedDates((prev) => ({ ...prev, [key]: date }));
  }, []);
  const formatDate = (date) => {
    if (!date) return "";
    const dateObj = Object.values(date);
    const upDatedDate = [];
    if (dateObj.length === 0) return "";
    dateObj.forEach((date) => {
      upDatedDate.push(new Date(date));
    });
    if (upDatedDate.length === 0) return "";
    const convertDate = upDatedDate.map((date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    });
    return convertDate;
  };
  
const handleRawInput = (key, rawValue) => {
  const trimmed = (rawValue || '').trim();
  // Clearing input (Backspace/Delete to empty) removes the date
  if (trimmed === '') {
    handleDateChange(key, null);
    return;
  }
  // Accept 1-2 digit day numbers only
  if (!/^\d{1,2}$/.test(trimmed)) return;
  const rawDate = `${key}-${trimmed}`; // key is YYYY-MM
  const fullDate = parseDDMMYYYY2(rawDate);
  if (fullDate) {
    const inputKey = `${fullDate.getFullYear()}-${String(fullDate.getMonth() + 1).padStart(2, "0")}`;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (
      fullDate.getFullYear() === today.getFullYear() &&
      fullDate.getMonth() === today.getMonth() &&
      fullDate < today
    ) {
      return; // disallow past day in current month
    }
    handleDateChange(inputKey, fullDate);
  }
};
 
const parseDDMMYYYY2 = (str) => {
    const [year, month,day ] = str.split("-").map(Number);
    if (!day || !month || !year) return null;
    const date = new Date(year, month - 1, day);
    return isNaN(date.getTime()) ? null : date;
  };


  return (
    <div className="row p-2">
      {/* Tabs */}
      <div className="col-sm-12">
        <se-tabbar color="alternative" className="nav nav-tabs mb-4">
          <nav role="tablist" aria-label="Years">
            {years.map((year) => (
              <a
                key={year}
                role="tab"
                id={`tab-${year}`}
                className={activeYear === year ? "active" : ""}
                aria-selected={activeYear === year}
                aria-controls={`panel-${year}`}
                tabIndex={activeYear === year ? 0 : -1}
                 onClick={() => {
                  setOpenKey(null); // close any open calendar on year switch
                  setActiveYear(year);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setOpenKey(null);
                    setActiveYear(year);
                  }
                }}
              >
                {year}
              </a>
            ))}
          </nav>
        </se-tabbar>
      </div>

      {/* Tab Content */}
      {activeYear && (
        <div 
          className={` col-sm-12  ${
          siteCreated ||
          projectStatusData?.projectStatus === "COMPLETED" ||
          projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
            ? "se-block-disabled not-allowed"
            : ""
        }`}
        >
          <section
            id={`panel-${activeYear}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeYear}`}
          >
            <div className="row">
              {grouped[activeYear].map(({ key, label, min, max }) => {
                const inputId = `date-${key}`;
                const value = selectedDates?.[key] || null;

                // Calculate today's date (without time)
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const minDateObj = new Date(min);
                // Only restrict to today if this is the current month and year
                const isCurrentMonth = minDateObj.getFullYear() === today.getFullYear() && minDateObj.getMonth() === today.getMonth();
                const isCurrentDay = isCurrentMonth && (value ===null ||value?.getDay() < today.getDay()) ?true:false;
                const minDate = isCurrentMonth && minDateObj < today ? today : minDateObj;
                return (
                  <div key={key} className={`col-md-2 col-sm-3 mb-3 p-1 ${isCurrentDay?"se-block-disabled not-allowed":""}`}>
                    <div className="card">
                      <div className="card-body d-flex text-center p-2">
                        <h5 className="card-title m-0 mr-1 text-center pt-1">{label}</h5>
                        <DatePicker
                          id={inputId}
                          className="form-control form-control-sm text-center pl-1"
                          selected={value}
                          onChange={(date) => handleDateChange(key, date)}
                          dateFormat="dd"
                          minDate={new Date(min)}
                          // minDate={minDate}
                          maxDate={new Date(max)}
                          onChangeRaw={(e) => handleRawInput(key, e.target.value)}
                           open={openKey === key}     
                          onInputClick={() => setOpenKey(key)}
                          onFocus={() => setOpenKey(key)}
                          onClickOutside={() => setOpenKey(null)}
                          onCalendarClose={() => setOpenKey(null)}
                          shouldCloseOnSelect
                          
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default Calendar24Months;
